// extracted by mini-css-extract-plugin
export default {"suggested_list":"social-suggested-followees-SuggestedMembersModal__suggested_list--32oEk","suggestions":"social-suggested-followees-SuggestedMembersModal__suggestions--CC_tY"};